/* CM: "Show more" im Combine-&-Save-Widget.
   Stufen: 6 sichtbar -> +6 (12) -> +6 (18), danach verschwindet der Button.
   Nur mobil sichtbar (Desktop blendet den Button per CSS aus).
   Event-Delegation auf document: funktioniert auch dann, wenn die Sektion
   erst nachtraeglich per Section-Rendering eingesetzt oder gemorpht wird. */
(function () {
  if (window.__cmRecsMore) return;
  window.__cmRecsMore = true;

  var STEPS = [6, 12, 18];

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cm-pr-more]');
    if (!btn) return;
    e.preventDefault();

    var root = btn.closest('[data-cm-pr]');
    if (!root) return;

    var step = parseInt(root.getAttribute('data-step') || '0', 10);
    var next = Math.min(step + 1, 2);
    var items = root.querySelectorAll('.resource-list__item');

    for (var i = STEPS[step]; i < Math.min(STEPS[next], items.length); i++) {
      items[i].classList.add('is-new');
    }

    root.setAttribute('data-step', String(next));

    /* Button weg, sobald alles sichtbar ist (letzte Stufe oder keine Produkte mehr). */
    if (next >= 2 || items.length <= STEPS[next]) {
      root.setAttribute('data-step', '2');
    }
  });
})();
